import React from 'react';
import { Home } from './../../elements/HomeElements';
import { Link } from 'gatsby';

const HomeSections = () => (
    <Home>
        <div className="section-a">
            <div className="container">
                <div className="home-intro">
                    <h4>Changing Lives Of Young People</h4>
                    <p>The organisation is aim for mostly young people to stay motivated and give back to their community in any way possible.</p>
                </div>
            </div>
        </div>
        <div className="section-b">
            <div className="container">
                <div className="three-blocks">
                    <div className="block">
                        <img src="zapowerhouse.jpg" alt="Zanele Phakathi Wearing Za Power House T-Shirt" />
                        <h5>About Us</h5>
                        <p>
                            Za Power House is a award winning non-profit organisation that was founded by Zanele Phakathi 
                            who felt the need to give back to her community.
                        </p>
                        <Link to="/about" className="btn">Read More</Link>
                    </div>
                    <div className="block">
                        <img src="zapowerhouse-mission.jpg" alt="Za Power House Team Giving Back" />
                        <h5>What We Do</h5>
                        <p>
                            We strive in creating a Soweto with responsibility,
                            hardworking and vibrant young people,
                            and while doing that to create a united
                            community that always helps one another.
                        </p>
                        <Link to="/projects" className="btn">Read More</Link>
                    </div>
                    <div className="block">
                        <img src="zapowerhouse-donate.jpg" alt="Zanele Phakathi Helping The Future Leaders Of South Africa" />
                        <h5>What Do We Need From You?</h5>
                        <p>
                        Not only will your company make our dream come true and
                        help meet a need in an area that is underdeveloped and
                        underutilised but will also fulfil dreams of young people who
                        wish to bring about great change in their communities.
                        </p>
                        <Link to="/donate" className="btn">Donate Today</Link>
                    </div>
                </div>
            </div>
        </div>
        <div className="section-c">
            <div className="container">
                <h2>Achievements</h2>
                <div className="achievements">
                    <div className="achievement">
                        <h3>Phenomenal Woman Of The Year</h3>
                        <img src="phenomenal.png" alt="Zanele Phakathi Phenomenal Woman Of The Year" />
                    </div>
                    <div className="achievement">
                        <h3>Women Of Stature Awards</h3>
                        <img src="womanaward.png" alt="Zanele Phakathi Women Of Stature Awards" />
                    </div>
                    <div className="achievement">
                        <h3>SA Hero Awards</h3>
                        <img src="saheroes.png" alt="Zanele Phakathi SA Hero Awards" />
                    </div>
                    <div className="achievement">
                        <h3>Rainmaker Award</h3>
                        <img src="rainmaker.png" alt="Zanele Phakathi Rainmaker Award" />
                    </div>
                </div>
            </div>
        </div>
    </Home>
)

export default HomeSections;